/* unplugin-vue-components disabled */import script from "./welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./welcome.vue?vue&type=script&setup=true&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=4dd0e716&lang=less"

const __exports__ = script;

export default __exports__